import { Badge, Button, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import PeopleIcon from '@material-ui/icons/PeopleOutline';
import { format, parse } from 'date-fns';
import React from 'react';
import VigenciaPorteApi from '../../api/VigenciaPorteApi';
import DialogSlideEquipe from './DialogSlideEquipe';

const styles = theme => ({

  buttonOperation: {
    fontSize: 'small',
    margin: theme.spacing(0.25),
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(0.5),
    padding: theme.spacing(0.25),
    minWidth: theme.spacing(3),
    maxWidth: theme.spacing(3),
    minHeight: theme.spacing(3),
    maxHeight: theme.spacing(3),
  },
  badge: {
    top: '5%',
    right: 5,
    width: theme.spacing(2),
    height: theme.spacing(2),
    color: theme.palette.secondary.main,
    backgroundColor: 'transparent',
  },
  typographyDesc: {
    fontSize: 12,
    marginBottom: theme.spacing(0.5),
  },
  typographyValor: {
    fontSize: 12,
    marginBottom: theme.spacing(0.5),
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
    divTypography: {
      display: 'inline',
      textAlign: 'left'
    },
  }
});

class ButtonEquipe extends React.Component {
  vigenciaPorteApi = new VigenciaPorteApi();
  state = {
    dialogOpen: false,
    posicaoProf: '',
    percentual: 0,
    valUnitarioVigente: this.props.valUnitarioVigente
  }
  componentDidMount = async () => {
    if (this.props.equipe && this.props.equipe.length === 1){

      let posicaoProf = this.props.equipe[0].split('-')[0].trim();
      let percentual = 0;
      let valUnitarioVigente = this.state.valUnitarioVigente;

      if (posicaoProf === 'Cirurgião'){
        percentual = 1;
      }
      if (posicaoProf === 'Primeiro Auxiliar'){
        percentual = 0.3;
      }
      if (posicaoProf === 'Segundo Auxiliar'){
        percentual = 0.2;
      }
      if (posicaoProf === 'Terceiro Auxiliar'){
        percentual = 0.2;
      }
      if (posicaoProf === 'Quarto Auxiliar'){
        percentual = 0.2;
      }
      if (posicaoProf === 'Instrumentador'){
        percentual = 0.1;
      }
      if (posicaoProf === 'Anestesista'){
        percentual = 1;
        valUnitarioVigente = await this.vigenciaPorteApi.consultarValorPorte(this.props.codPorteAnestesico, this.props.dtaRealizacao);
      }
      this.setState({percentual: percentual, posicaoProf: posicaoProf, valUnitarioVigente: valUnitarioVigente});
    }
  }
  handleCloseDialog = () => {
    this.setState({dialogOpen: false});
  }

  handleClick = () => {
    this.setState({dialogOpen: true});
  }

  render () {
    const { title, equipe, classes, codPorteAnestesico, dtaRealizacao } = this.props;
    const { percentual, posicaoProf, valUnitarioVigente } = this.state;
    const nf = new Intl.NumberFormat('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return (
      equipe && equipe.length === 1
      ? <React.Fragment>
        <Button
          color='secondary'
          className={classes.buttonOperation}
          title='Equipe Médica'
          onClick={this.handleClick}>
          <PeopleIcon />
        </Button>
        {posicaoProf !== 'Anestesista' &&
          <div style={{display: 'flex'}}>
            <Typography
              color='secondary'
              title={percentual === 0 ? 'Posição Profissional' : 'Valor unitário vigente para ' + (percentual * 100) + '% de R$' + nf.format(valUnitarioVigente)}
              className={classes.typographyDesc}>{posicaoProf}
            </Typography>
            <Typography
              color='secondary'
              title={'Clique para alterar o Valor Unitário Autorizado'}
              onClick={() => this.props.selecionarValor(valUnitarioVigente * percentual)}
              className={classes.typographyValor}>{percentual === 0 ? '' : ' - R$' + nf.format(valUnitarioVigente * percentual)}
            </Typography>
        </div>
        }
        {posicaoProf === 'Anestesista' &&
        <div style={{display: 'flex'}}>
          <Typography
            color='secondary'
            title={codPorteAnestesico === null ? 'Posição Profissional' : 'Valor do porte anestésico ' + codPorteAnestesico + ' em ' + format(parse(dtaRealizacao), 'DD/MM/YYYY') + ': R$' + nf.format(valUnitarioVigente)}
            className={classes.typographyDesc}>{posicaoProf}
          </Typography>
          <Typography
              color='secondary'
              title={'Clique para alterar o Valor Unitário Autorizado'}
              className={classes.typographyValor}>{valUnitarioVigente === 0 ? '' : ' - R$' + nf.format(valUnitarioVigente)}
            </Typography>
        </div>
        }
        <DialogSlideEquipe
          open={this.state.dialogOpen}
          title={title}
          equipe={equipe}
          handleClose={this.handleCloseDialog}
        />
      </React.Fragment>
      : equipe && equipe.length > 1 &&
      <React.Fragment>
        <Badge badgeContent={equipe.length} color='secondary' classes={{ badge: classes.badge }}>
          <Button
            color='secondary'
            className={classes.buttonOperation}
            title='Equipe Médica'
            onClick={this.handleClick}>
            <PeopleIcon />
          </Button>
        </Badge>
        <DialogSlideEquipe
          open={this.state.dialogOpen}
          title={title}
          equipe={equipe}
          handleClose={this.handleCloseDialog}
        />
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(ButtonEquipe);
